(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-alternate"]) return;
  try {
    


$(document).ready(function(){

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    

function instagramWidget() {
  var $galleryContainer = $(".instagram-feed__container");
    
  var accessToken     = $galleryContainer.data("token");    
  var gridClass       = $galleryContainer.data("grid");
  var numberOfRows    = $galleryContainer.data("rows");
  var numberOfColumns = $galleryContainer.data("columns");
  var displayCaptions = $galleryContainer.data("captions");
  var numberOfImages  = numberOfRows * numberOfColumns;


  function fetchImages() {
    var InstagramAPI = "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + accessToken + "&count=" + numberOfImages;

    if(accessToken !== undefined) {
      var request = $.ajax({
        type: "GET",
        dataType: "jsonp",
        url: InstagramAPI
      });

      request.done(function(result){
        if (result.meta.code == 200) {
          displayImages(result);
        } else {
		  console.log(result.meta.error_message);
          return;
        }
      }).fail(function(error){
		console.log(error);
        return;
      });
    }
  }
  

  function displayImages(result) {
    var $imgOverlay, $imgLink, $imgWrap;

    for (var i = 0; i < numberOfImages; i++) {
      if(displayCaptions) {
        $imgOverlay = $("<div>", { "class": "grid__item--overlay" }).append($("<div>", { "class": "grid__item--overlay-details", text: result.data[i].caption.text }));                             
    
        $imgLink = $("<a>", { href: result.data[i].link })
                     .append($("<img>", { src: result.data[i].images.standard_resolution.url, alt: result.data[i].caption.text }))
                     .append($imgOverlay);
                                                    
        $imgWrap = $("<div>", {"class": "grid__item " + gridClass}).append($imgLink);
        
        $(".instagram-feed__container .grid")
          .append($imgWrap);
      } else {
        $imgLink = $("<a>", { href: result.data[i].link })
                     .append($("<img>", { src: result.data[i].images.standard_resolution.url, alt: result.data[i].caption.text }));
        
        $imgWrap = $("<div>", {"class": "grid__item " + gridClass}).append($imgLink);
                                       
        $(".instagram-feed__container .grid")
          .append($imgWrap);                              
      }                            
    }
  }
  
                                       
  fetchImages();
}


$(document).ready(function() {
  instagramWidget();
});

                                       
/* Rerun scripts when making changes in the theme editor */
                                                 
function reloadInstagramWidget() {
  $(".instagram-feed__container .grid").empty();                                    
  instagramWidget()
}

document.addEventListener("shopify:section:select", reloadInstagramWidget, false);                                              


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax"] && !Shopify.designMode) return;
  try {
    

/*!
 * Object Fit Images
 * Copyright (c) Federico Brigante
 * MIT Licence (https://raw.githubusercontent.com/bfred-it/object-fit-images/master/license)
 * npm.im/object-fit-images 3.2.3
 */

var objectFitImages=function(){"use strict";function t(t,e){return"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='"+t+"' height='"+e+"'%3E%3C/svg%3E"}function e(t){if(t.srcset&&!m&&window.picturefill){var e=window.picturefill._;t[e.ns]&&t[e.ns].evaled||e.fillImg(t,{reselect:!0}),t[e.ns].curSrc||(t[e.ns].supported=!1,e.fillImg(t,{reselect:!0})),t.currentSrc=t[e.ns].curSrc||t.src}}function i(t){for(var e,i=getComputedStyle(t).fontFamily,r={};null!==(e=l.exec(i));)r[e[1]]=e[2];return r}function r(e,i,r){var n=t(i||1,r||0);p.call(e,"src")!==n&&b.call(e,"src",n)}function n(t,e){t.naturalWidth?e(t):setTimeout(n,100,t,e)}function c(t){var c=i(t),o=t[a];if(c["object-fit"]=c["object-fit"]||"fill",!o.img){if("fill"===c["object-fit"])return;if(!o.skipTest&&g&&!c["object-position"])return}if(!o.img){o.img=new Image(t.width,t.height),o.img.srcset=p.call(t,"data-ofi-srcset")||t.srcset,o.img.src=p.call(t,"data-ofi-src")||t.src,b.call(t,"data-ofi-src",t.src),t.srcset&&b.call(t,"data-ofi-srcset",t.srcset),r(t,t.naturalWidth||t.width,t.naturalHeight||t.height),t.srcset&&(t.srcset="");try{s(t)}catch(t){window.console&&console.warn("https://bit.ly/ofi-old-browser")}}e(o.img),t.style.backgroundImage='url("'+(o.img.currentSrc||o.img.src).replace(/"/g,'\\"')+'")',t.style.backgroundPosition=c["object-position"]||"center",t.style.backgroundRepeat="no-repeat",t.style.backgroundOrigin="content-box",/scale-down/.test(c["object-fit"])?n(o.img,function(){o.img.naturalWidth>t.width||o.img.naturalHeight>t.height?t.style.backgroundSize="contain":t.style.backgroundSize="auto"}):t.style.backgroundSize=c["object-fit"].replace("none","auto").replace("fill","100% 100%"),n(o.img,function(e){r(t,e.naturalWidth,e.naturalHeight)})}function s(t){var e={get:function(e){return t[a].img[e||"src"]},set:function(e,i){return t[a].img[i||"src"]=e,b.call(t,"data-ofi-"+i,e),c(t),e}};Object.defineProperty(t,"src",e),Object.defineProperty(t,"currentSrc",{get:function(){return e.get("currentSrc")}}),Object.defineProperty(t,"srcset",{get:function(){return e.get("srcset")},set:function(t){return e.set(t,"srcset")}})}function o(t,e){var i=!h&&!t;if(e=e||{},t=t||"img",f&&!e.skipTest||!d)return!1;"img"===t?t=document.getElementsByTagName("img"):"string"==typeof t?t=document.querySelectorAll(t):"length"in t||(t=[t]);for(var r=0;r<t.length;r++)t[r][a]=t[r][a]||{skipTest:e.skipTest},c(t[r]);i&&(document.body.addEventListener("load",function(t){"IMG"===t.target.tagName&&o(t.target,{skipTest:e.skipTest})},!0),h=!0,t="img"),e.watchMQ&&window.addEventListener("resize",o.bind(null,t,{skipTest:e.skipTest}))}var a="bfred-it:object-fit-images",l=/(object-fit|object-position)\s*:\s*([-\w\s%]+)/g,u="undefined"==typeof Image?{style:{"object-position":1}}:new Image,g="object-fit"in u.style,f="object-position"in u.style,d="background-size"in u.style,m="string"==typeof u.currentSrc,p=u.getAttribute,b=u.setAttribute,h=!1;return o.supportsObjectFit=g,o.supportsObjectPosition=f,function(){function t(t,e){return t[a]&&t[a].img&&("src"===e||"srcset"===e)?t[a].img:t}f||(HTMLImageElement.prototype.getAttribute=function(e){return p.call(t(this,e),e)},HTMLImageElement.prototype.setAttribute=function(e,i){return b.call(t(this,e),e,String(i))})}(),o}();


/*!
 * Materialize v0.100.1 (http://materializecss.com)
 * Copyright 2014-2017 Materialize
 * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)
 */

;(function ($) {

  $.fn.parallax = function () {
    var window_width = $(window).width();

    // Parallax Scripts
    return this.each(function (i) {
      var $this = $(this);
      $this.addClass('parallax');

      function updateParallax(initial) {
        var container_height;

        if (window_width < 601) {
          container_height = $this.height() > 0 ? $this.height() : $this.children("img").height();
        } else {
          container_height = $this.height() > 0 ? $this.height() : 600; /* changed from 500 */
        }

        var $img = $this.children("img").first();
        var img_height = $img.height();
        var parallax_dist = img_height - container_height;
        var bottom = $this.offset().top + container_height;
        var top = $this.offset().top;
        var scrollTop = $(window).scrollTop();
        var windowHeight = window.innerHeight;
        var windowBottom = scrollTop + windowHeight;
        var percentScrolled = (windowBottom - top) / (container_height + windowHeight);
        var parallax = Math.round(parallax_dist * percentScrolled);

        if (initial) {
          $img.css('display', 'block');
        }

        if (bottom > scrollTop && top < scrollTop + windowHeight) {
          $img.css('transform', "translate3D(0," + parallax + "px, 0)");
        }
      }

      // Wait for image load
      $this.children("img").one("load", function () {
        updateParallax(true);
      }).each(function () {
        if (this.complete) $(this).trigger("load");
      });

      $(window).scroll(function () {
        window_width = $(window).width();
        updateParallax(false);
      });

      $(window).resize(function () {
        window_width = $(window).width();
        updateParallax(false);
      });
    });
  };
})(jQuery);
                                                 
function initParallaxSection() {
  var $parallax_images = $('.parallax__image');
                                                 
  $('.parallax').parallax();
  objectFitImages($parallax_images);
}
                                                     
$(document).ready(function(){
  initParallaxSection();                                                                                             
});
                                                 

                                                 
/* Rerun scripts when making changes in the theme editor */
                                                 
function reloadParallax() {                                              
  initParallaxSection();
}

document.addEventListener("shopify:section:select", reloadParallax, false);                                                 
                                                 
                                                    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

$(document).ready(function(){
  $(".mosaic__grid").find(".mosaic__grid-item").each(function(){
    var gridItem = $(this);
    var images = $(this).find("img");
    var imgWidth, imgHeight;
  
    $("<img />").attr("src", $(images).attr("src")).on('load', function() {
      imgWidth = this.width;
      imgHeight = this.height;

      $(gridItem).css("flex-basis", imgWidth * 200 / imgHeight);
      $(gridItem).css("flex-grow", imgWidth * 200 / imgHeight);
    });
  });
});
  


  } catch(e) { console.error(e); }
})();
})();
